import { render, staticRenderFns } from "./MailEditInput.vue?vue&type=template&id=665e9588&lang=pug&"
import script from "./MailEditInput.vue?vue&type=script&lang=ts&"
export * from "./MailEditInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports